import React, { Component } from 'react'
import ScrollToTop from '../../../../components/ScrollToTop'
import MenuSider from '../../../../components/MenuSider'
import { connect } from 'react-redux'
import IntlMessages from '../../../../util/IntlMessages';
import { Form, DatePicker, TimePicker, Radio, Checkbox, Cascader, Button, Icon, Spin } from 'antd';
import moment from 'moment';
import './Newobservation.scss'
import { array } from 'prop-types';
import axios from 'axios'
import { Odata_Url, Constants } from '../../../../Constants/Constants'

const CheckboxGroup = Checkbox.Group;
const RadioGroup = Radio.Group;
const FormItem = Form.Item;
const format = 'HH:mm';
const plainOptions_EN = ['Employee', 'Contractor'];
const plainOptions_TH = ['พนักงาน', 'ผู้รับเหมา'];
var Token

class Basic_Info extends Component {
    constructor() {
        super();

        this.state = {
            Obtran: [],
            mode: 'create',
            value: 1,
            status: true,
            typeofobserved: "factory",
            style_active: "style_active",
            style_disable: "style_disable",
            set_basic_info: {
                observation_id: null,
                area: null,
                areaid: null,
                observation_date: null,
                shift: null,
                site: null,
                siteid: null,
                time: null,
                type_of_observed_people: null
            },
            mode: 'create',
            dataarea: [],
            loading: false
        }
    }

    componentDidUpdate(prevProps, prevState) {

        window.location.href = "observation/request";

        let stateEng = JSON.parse(window.localStorage.getItem('state'))
        let isEng = stateEng.setting.locale.locale == 'en'
        if (isEng !== prevState.isEng)
            this.setState({ isEng: isEng })
    }

    componentWillMount() {
        this.setState({ loading: true })
        let state = JSON.parse(window.localStorage.getItem('state'))
        let isEng = state.setting.locale.locale == 'en'
        this.setState({ isEng: isEng })
        this.initialData()
        if (this.props.location.state === undefined || this.props.location.state.Obtran) {
            this.props.CLEAR_BASIC_INFO()
            window.localStorage.removeItem("select_job")
            window.localStorage.removeItem("type_of_category")
            window.localStorage.removeItem("Select_Category")
            window.localStorage.removeItem("Detail_Category")
            window.localStorage.removeItem('detail_unsafe')
            window.localStorage.removeItem('detail_safe')
            window.localStorage.removeItem('nearmiss')
            window.localStorage.removeItem('detail_capa')
            this.props.CLEAR_IMAGE_CATEGORY()
        }
    }

    initialData() {
        let ObservHold = JSON.parse(window.localStorage.getItem('Observ_Hold')) || {}
        let observation_detail = this.props.location.state ? (this.props.location.state || {}).Obtran : ObservHold.Obtran || null
        let mode = this.props.location.state ? (this.props.location.state || {}).mode : ObservHold.mode || 'create'
        this.setState({ mode: mode })
        var AreaID = (observation_detail || {}).AreaID
        axios.get(Constants.BASE_URL + 'auth/token')
            .then((response) => {
                Token = response.data
                axios.get(Odata_Url + 'OAreaMD?$filter=IsActived eq true&$orderby=Name',
                    { headers: { "Authorization": "Bearer " + Token } }).then(async (response) => {
                        const data = [];
                        var AreaParent
                        var AreaOrder
                        var AreaBuilding

                        response.data.value.forEach(function (element) {
                            if (element.PKAreaID === AreaID) {
                                AreaParent = element.Parentid
                                AreaOrder = element.Ordering
                                AreaBuilding = {
                                    Id: element.PKAreaID,
                                    Name: element.Name,
                                    Parentid: element.Parentid,
                                    Ordering: element.Ordering
                                }
                            }
                            data.push(element);
                        });

                        var Areas = []
                        var Site = [AreaBuilding]
                        for (let i = 1; i < AreaOrder; i++) {
                            for (let j = 0; j < data.length; j++) {
                                if (data[j].PKAreaID === AreaParent) {
                                    let data_building = {
                                        Id: data[j].PKAreaID,
                                        Name: data[j].Name,
                                        Parentid: data[j].Parentid,
                                        Ordering: data[j].Ordering
                                    }
                                    if (i < 3)
                                        Site.splice(0, 0, data_building)
                                    else
                                        Areas.splice(0, 0, data_building)
                                    AreaParent = data[j].Parentid
                                    break;
                                }
                            }
                        }

                        window.localStorage.setItem('Area', JSON.stringify(data));
                        var area = data
                        this.setState({ dataarea: area })
                        var state = JSON.parse(window.localStorage.getItem('state'))
                        if (observation_detail) {
                            let observertype = await axios.get(Odata_Url + 'OObservation_ObserverType?$filter=IsActived eq true and ObTranID eq ' + observation_detail.PkObTranID,
                                { headers: { "Authorization": "Bearer " + Token } }).then(async (response) => {
                                    var dataobservertype = []
                                    response.data.value.forEach(function (element) {
                                        dataobservertype.push(element.ObserverType_Name)
                                    });
                                    return dataobservertype
                                });

                            Promise.all(observertype).then(res => {
                                state.set_basic_info.observation_id = observation_detail.PkObTranID
                                state.set_basic_info.area = Areas.map(x => x.Name)
                                state.set_basic_info.site = Site.map(x => x.Name)
                                state.set_basic_info.observation_date = observation_detail.Observation_Date
                                state.set_basic_info.time = observation_detail.Observation_Time
                                state.set_basic_info.shift = observation_detail.Shift
                                state.set_basic_info.type_of_observed_people = res
                                state.Obtran = observation_detail
                                this.props.SET_SITEID((area.find(x => x.Name == Areas[2].Name && x.Parentid === Areas[2].Parentid) || {}).PKAreaID)
                                this.props.SET_AREAID((area.find(x => x.Name == Site[2].Name && x.Parentid === Site[2].Parentid) || {}).PKAreaID)

                                var Area = state.set_basic_info.area
                                if (Area === null)
                                    this.setState({ ...state, status: true })
                                else
                                    this.setState({ ...state, status: false })
                                this.setState({ loading: false })
                            })
                        } else {
                            var Area = state.set_basic_info.area

                            if (Area === null)
                                this.setState({ ...state, status: true })
                            else
                                this.setState({ ...state, status: false })
                            this.setState({ loading: false })
                        }
                    }, (error) => {
                        console.log(error);
                    });
            }, (error) => {
                console.log(error);
                if (401 === error.response.status) {
                    window.location.href = "auth";
                }
            });
    }

    disabledDate(current) {

        // Can not select days before today and today
        // console.log(current)
        var rules = (current < moment().startOf('month')) || (current > moment().endOf('day'))
        return current && rules;
    }
    onChange_shift = (e) => {

        // console.log('radio checked', e.target.value);
        this.setState({
            value: e.target.value,
        });
    }
    onChange = (value, selectedOptions) => {
        //SOT-15
        var area = JSON.parse(window.localStorage.getItem('Area'))
        this.setState({ dataarea: area })

        this.props.CLEAR_SITE();
        this.props.form.resetFields(['site']);
        // console.log(value, selectedOptions);
        var province_id
        this.state.dataarea.map((l, i) => {
            if (l.Name === value[1]) {
                province_id = l.PKAreaID
            }
            return null
        })
        this.state.dataarea.map((l, i) => {
            if (l.Name === value[2] && l.Parentid === province_id) {
                // console.log(l.PKAreaID)
                this.props.SET_SITEID(l.PKAreaID)
            }
            return null
        })
        if (value.length === 0) {
            this.setState({
                status: true
            })
        } else {
            this.setState({
                status: false
            })
        }
        // console.log(this.props.detail.SiteID)
    }
    ChangeSite = (value, selectedOptions) => {
        var basic_info = this.props.set_basic_info
        var site = basic_info.siteid
        var areaTopParentID
        var areaParentID
        this.state.dataarea.map((l, i) => {
            this.state.dataarea.map((l, i) => {
                if (l.Name === value[0] && l.Ordering === 4 && l.Parentid === site) {
                    areaTopParentID = l.PKAreaID
                }
                return true
            })
            this.state.dataarea.map((l, i) => {
                if (l.Name === value[1] && l.Ordering === 5 && l.Parentid === areaTopParentID) {
                    areaParentID = l.PKAreaID
                }
                return true
            })
            this.state.dataarea.map((l, i) => {
                if (l.Name === value[2] && l.Parentid === areaParentID) {
                    this.props.SET_AREAID(l.PKAreaID)
                }
                return true
            })
            return true
        })
    }
    filter(inputValue, path) {
        return path.some(
            option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
        );
    }
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                // console.log('Received values of form: ', values)
                var date2 = values.observation_date
                date2.toJSON = function () { return moment(this).format(); }
                var Stringdate2 = JSON.stringify(date2)
                var observation_date = Stringdate2.slice(1, 11)
                var time = values.time._d
                var Hours = time.getHours()
                var Minutes = time.getMinutes()
                if (Hours < 10) {
                    Hours = "0" + Hours
                }
                if (Minutes < 10) {
                    Minutes = "0" + Minutes
                }
                var value = values
                var time2 = (Hours + ":" + Minutes)
                value.observation_date = observation_date
                value.observation_id = this.state.set_basic_info.observation_id
                value.time = time2
                this.props.SET_BASIC_INFO(value)
                let ObservHold = JSON.parse(window.localStorage.getItem('Observ_Hold'))
                let location = this.props.location
                if (location.state ? (location.state || {}).Obtran : (ObservHold || {}).Obtran) {
                    this.setState({ loading: true })
                    Promise.all([this.getJobType(),
                    this.getJobTypeId(),
                    this.getCatagoryDetail(),
                    this.getSubCatagoryDetail(),
                    this.getSelectCategory(),
                    this.getUserInfo()]).then(([job, jobTypeId, catagoryDetail, subCatagoryDetail, SelectCategory, UserInfo]) => {
                        let selectedUser = {
                            userId: UserInfo.pkUserID,
                            userName: UserInfo.user_Name,
                            fullNameEN: UserInfo.userFullName_ENG,
                            fullNameTH: UserInfo.userFullName_TH,
                            email: UserInfo.email_Address,
                            manager: this.state.Obtran.ResponsibleManager,
                            managerEmail: UserInfo.managerEmail,
                            cc: ''
                        }

                        var jobType = JSON.parse(window.localStorage.getItem('Jobtype'))
                        let isOffice = jobType.find(x => x.PKJobTypeID === jobTypeId.JobTypeID).Type === 'office'
                        let initialjob = []
                        job.map((l, i) => {
                            let id = l.PKJobTypeID === jobTypeId.JobTypeID ? 1 : 0
                            initialjob[i] = { factory: isOffice ? 0 : id, office: isOffice ? id : 0 }
                        })

                        let detail_capa = { capa_action: this.state.Obtran.CapaAction, user: selectedUser, type: this.state.Obtran.ActionType, due_date: this.state.Obtran.DueDate };
                        let action_detail_unsafe = { detail1: this.state.Obtran.Unsafe_detail_corrective_action, detail2: this.state.Obtran.Unsafe_detail_next_action }
                        window.localStorage.setItem("nearmiss", this.state.Obtran.Nearmiss)
                        window.localStorage.setItem("detail_unsafe", JSON.stringify(action_detail_unsafe))
                        window.localStorage.setItem("detail_safe", JSON.stringify({ detail: this.state.Obtran.Safe_detail }))
                        window.localStorage.setItem("detail_capa", JSON.stringify(detail_capa))

                        window.localStorage.setItem('select_job', JSON.stringify(initialjob))
                        window.localStorage.setItem('Detail_Category', JSON.stringify(catagoryDetail))
                        window.localStorage.setItem('type_of_category', JSON.stringify(subCatagoryDetail))
                        window.localStorage.setItem('Select_Category', JSON.stringify(SelectCategory))
                        window.localStorage.setItem("status_of_observed", SelectCategory.filter(x => x.text === "Unsafe").length > 0 ? 'unsafe' : 'safe');
                        window.localStorage.removeItem('Observ_Hold')

                        this.props.history.push({
                            pathname: "/newobservation_checklist",
                            state: { back: 'basic_info', mode: this.state.mode }
                        });
                    })

                } else {
                    this.props.history.push({
                        pathname: "/newobservation_checklist",
                        state: { back: 'basic_info', mode: this.state.mode }
                    });
                }
            }
        });
    }

    async getJobTypeId() {
        return await axios.get(
            Odata_Url + 'OObservation_Job_Detail?$filter=IsActived eq true and ObTranID eq ' + this.state.Obtran.PkObTranID,
            { headers: { "Authorization": "Bearer " + Token } }).then((response) => {
                return response.data.value ? response.data.value[0] : -1
            })
    }

    async getCatagoryDetail() {
        let token = await this.getToken();
        let tokenHeader = {
            headers: { "Authorization": "Bearer " + token, }
        };
        return await axios.get(Constants.BASE_URL + 'api/Observation/GetObservationCategoryDetailWithMD?PkObTranID=' + this.state.Obtran.PkObTranID, tokenHeader).then((response) => {
            return response.data
        })
    }

    async getSubCatagoryDetail() {
        let token = await this.getToken();
        let tokenHeader = {
            headers: { "Authorization": "Bearer " + token, }
        };
        return await axios.get(Constants.BASE_URL + 'api/Observation/GetObservationSubCategoryDetailWithMD?PkObTranID=' + this.state.Obtran.PkObTranID, tokenHeader).then((response) => {
            return response.data
        })
    }

    async getSelectCategory() {
        let token = await this.getToken();
        let tokenHeader = {
            headers: { "Authorization": "Bearer " + token, }
        };
        return await axios.get(Constants.BASE_URL + 'api/Observation/GetObservationSelectCategory?PkObTranID=' + this.state.Obtran.PkObTranID, tokenHeader).then((response) => {
            return response.data
        })
    }

    async getUserInfo() {
        let token = await this.getToken();
        let tokenHeader = {
            headers: { "Authorization": "Bearer " + token, }
        };
        return await axios.get(Constants.BASE_URL + 'api/User/GetByPKUserID?PKUserID=' + this.state.Obtran.UserResponsible, tokenHeader).then((response) => {
            return response.data
        })
    }

    async getJobType() {
        this.setState({ loading: true })
        return await axios.get(Odata_Url + 'OJobType?$filter=IsActived eq true',
            { headers: { "Authorization": "Bearer " + Token } }).then((response) => {
                const data = [];
                response.data.value.forEach(function (element) {
                    data.push(element);
                });
                window.localStorage.setItem('Jobtype', JSON.stringify(data));
                return data;
            }, (error) => {
                console.log(error);
            });
    }

    getToken() {
        var $getToken = new Promise((resolve, reject) => {
            axios.get(Constants.BASE_URL + 'auth/token').then((res) => {
                resolve(res.data);
            }).catch(err => {
                if (401 === err.response.status) {
                    window.location.href = "auth";
                }
                reject(err);
            });
        });
        return $getToken;
    }

    render() {
        const { mode } = this.state
        const view = mode === 'view'
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };


        const area = [];
        const site = [];
        const country = [];
        const province = [];
        const sub_area = [];
        const sub_site = [];
        const building = [];
        const sub_building = [];

        this.state.dataarea.map(l => {
            if (l.Ordering === 1)
                country.push({ name: l.Name, id: l.PKAreaID })
            if (l.Ordering === 2)
                province.push({ name: l.Name, parentid: l.Parentid, id: l.PKAreaID })
            if (l.Ordering === 3)
                sub_area.push({ name: l.Name, parentid: l.Parentid })
            if (l.Ordering === 4)
                sub_site.push({ name: l.Name, parentid: l.Parentid, id: l.PKAreaID })
            if (l.Ordering === 5)
                building.push({ name: l.Name, parentid: l.Parentid, id: l.PKAreaID })
            if (l.Ordering === 6)
                sub_building.push({ name: l.Name, parentid: l.Parentid })
        })

        country.map((l, i) => {
            return (
                area.push(
                    {
                        value: l.name,
                        label: l.name,
                        children:
                            province.filter(function (province) {
                                if (province.parentid === l.id)
                                    return true;
                                else
                                    return false;
                            }).map((k, j) => {
                                return (
                                    {
                                        value: k.name,
                                        label: k.name,
                                        children:
                                            sub_area.filter(function (sub_area) {
                                                if (sub_area.parentid === k.id)
                                                    return true
                                                else
                                                    return false
                                            }).map((a, b) => {
                                                return (
                                                    {
                                                        value: a.name,
                                                        label: a.name
                                                    }
                                                )
                                            })
                                    }
                                )
                            })
                    }
                )
            )
        })
        sub_site.map((l, i) => {
            if (l.parentid === this.props.set_basic_info.siteid) {
                return (
                    site.push(
                        {
                            value: l.name,
                            label: l.name,
                            children:
                                building.filter(function (building) {
                                    if (building.parentid === l.id) {
                                        return true;
                                    } else {
                                        return false;
                                    }
                                }).map((k, j) => {
                                    return (
                                        {
                                            value: k.name,
                                            label: k.name,
                                            children:
                                                sub_building.filter(function (sub_building) {
                                                    if (sub_building.parentid === k.id) {
                                                        return true;
                                                    } else {
                                                        return false;
                                                    }
                                                }).map((a, b) => {
                                                    return (
                                                        {
                                                            value: a.name,
                                                            label: a.name
                                                        }
                                                    )
                                                })
                                        }
                                    )
                                })
                        }
                    )
                )
            } else {
                return ""
            }
        })

        var Date2 = this.state.set_basic_info.observation_date
        var time = this.state.set_basic_info.time
        var initialValueDate
        if (Date2) {
            var date = Date2.slice(8, 10)
            var month = Date2.slice(5, 7)
            var year = Date2.slice(0, 4)
            var date_time = (date + "-" + month + "-" + year)
            initialValueDate = date_time
        } else {
            initialValueDate = moment()
        }

        var datetime = new Date();
        var Hours = datetime.getHours();
        var Minutes = datetime.getMinutes();
        var times = (Hours + ":" + Minutes)
        var initialValueTime
        if (time !== null)
            initialValueTime = time
        else
            initialValueTime = times

        var initialValueType_of_observed_people = this.state.set_basic_info.type_of_observed_people

        var plainOptions
        if (this.state.isEng) {
            plainOptions = plainOptions_EN
            if (typeof (initialValueType_of_observed_people) === array) {
                for (let i = 0; i < initialValueType_of_observed_people.length; i++) {
                    if (initialValueType_of_observed_people[i] === "พนักงาน") {
                        initialValueType_of_observed_people[i] = "Employee"
                    }
                    if (initialValueType_of_observed_people[i] === "ผู้รับเหมา") {
                        initialValueType_of_observed_people[i] = "Contractor"
                    }
                }
            }
        } else {
            plainOptions = plainOptions_TH
            if (typeof (initialValueType_of_observed_people) === array) {
                for (let i = 0; i < initialValueType_of_observed_people.length; i++) {
                    if (initialValueType_of_observed_people[i] === "Employee") {
                        initialValueType_of_observed_people[i] = "พนักงาน"
                    }
                    if (initialValueType_of_observed_people[i] === "Contractor") {
                        initialValueType_of_observed_people[i] = "ผู้รับเหมา"
                    }
                }
            }
        }

        return (
            <div>
                <ScrollToTop />
                <Spin spinning={this.state.loading} size="large" style={{ top: "50%" }} tip="Loading...">
                    <MenuSider title={<IntlMessages id="basic.topic_step1_basic_info" />} >
                        <div className='basic'>
                            <Form onSubmit={this.handleSubmit} style={{ width: "100%", fontSize: "13px" }} >
                                <div className="basic_form">
                                    <div style={{ width: "100%" }}>
                                        <div className="basic_div_date">
                                            <IntlMessages id="basic.observation_date" />
                                            <FormItem
                                                {...formItemLayout}
                                            >
                                                {
                                                    getFieldDecorator('observation_date', {
                                                        rules: [{
                                                            required: true, message: 'Please input Observation Date!',
                                                        }],
                                                        initialValue: moment(initialValueDate, 'DD MM YYYY'),
                                                    })(
                                                        <DatePicker
                                                            className="basic_date"
                                                            format="DD-MM-YYYY"
                                                            disabledDate={this.disabledDate}
                                                            disabled={view}
                                                            onChange={this.onChangedate}
                                                        />
                                                    )}
                                            </FormItem>
                                        </div>
                                        <div className="basic_div_time">
                                            <IntlMessages id="basic.time" />
                                            < FormItem
                                                {...formItemLayout}
                                            >
                                                {
                                                    getFieldDecorator('time', {
                                                        rules: [{
                                                            required: true, message: 'Please input Time!',
                                                        }],
                                                        initialValue: moment(initialValueTime, 'h:mm')
                                                    })(
                                                        <TimePicker
                                                            className="basic_time"
                                                            format={format}
                                                            // disabledHours={this.disabledHours}
                                                            // disabledMinutes={this.disabledMinutes}
                                                            placeholder="12:00"
                                                            inputReadOnly={true}
                                                            disabled={view}
                                                        />
                                                    )}
                                            </FormItem >
                                        </div>
                                    </div>
                                    <div >
                                        <IntlMessages id="basic.type_of_observed_people" />
                                        < FormItem
                                            {...formItemLayout}
                                        >
                                            {
                                                getFieldDecorator('type_of_observed_people', {
                                                    rules: [{
                                                        required: true, message: 'Please input type of observed people!',
                                                    }],
                                                    initialValue: initialValueType_of_observed_people
                                                })(

                                                    < CheckboxGroup options={plainOptions} disabled={view} />

                                                )}
                                        </FormItem >
                                    </div>
                                    <div >
                                        <IntlMessages id="basic.shift" />
                                        < FormItem
                                            {...formItemLayout}
                                        >
                                            {
                                                getFieldDecorator('shift', {
                                                    rules: [{
                                                        required: true, message: 'Please input shift!',
                                                    }],
                                                    initialValue: this.state.set_basic_info.shift
                                                })(
                                                    <RadioGroup onChange={this.onChange_shift} disabled={view}>
                                                        <Radio value="Daytime"><IntlMessages id="basic.shift_Daytime" /></Radio>
                                                        <Radio value="Shift"><IntlMessages id="basic.shift_Shift" /></Radio>
                                                    </RadioGroup>
                                                )}
                                        </FormItem >
                                    </div>

                                    <div style={{ width: "100%" }}>
                                        <IntlMessages id="basic.area" />
                                        < FormItem
                                            {...formItemLayout}
                                        >
                                            {
                                                getFieldDecorator('area', {
                                                    rules: [{
                                                        required: true, message: 'Please select area',
                                                    }],
                                                    initialValue: this.state.set_basic_info.area
                                                })(
                                                    <Cascader
                                                        className="basic_area"
                                                        options={area}
                                                        onChange={this.onChange}
                                                        expandTrigger="hover"
                                                        placeholder="Please select"
                                                        disabled={view}
                                                    // showSearch={this.filter}
                                                    />
                                                )}
                                        </FormItem >
                                    </div>
                                    {/* <MediaQuery maxDeviceWidth={575}> */}
                                    <div >
                                        <IntlMessages id="basic.site" />
                                        < FormItem
                                            {...formItemLayout}
                                        >
                                            {
                                                getFieldDecorator('site', {
                                                    rules: [{
                                                        required: true, message: 'Please select area ',
                                                    }],
                                                    initialValue: this.state.set_basic_info.site
                                                })(
                                                    <Cascader
                                                        className="basic_site"
                                                        options={site}
                                                        onChange={this.ChangeSite}
                                                        disabled={this.state.status}
                                                        expandTrigger="hover"
                                                        placeholder="Please select"
                                                        disabled={view}
                                                    // showSearch={this.filter}
                                                    />
                                                )}
                                        </FormItem >
                                    </div>
                                </div>
                                <div style={{ width: "100%", textAlign: "center", position: "fixed", bottom: "0", height: "48px" }} >
                                    <Button htmlType="submit" style={{ width: "100%", height: "100%", fontSize: "18px", border: "1px solid rgb(1 135 124)", padding: "3px", color: "white", backgroundColor: "rgb(0,152,139)", borderRadius: "0" }}>
                                        <IntlMessages id='Next' />
                                        <Icon type="caret-right" style={{ position: "relative", top: "1px", left: "-4px" }} />
                                    </Button>
                                </div>
                            </Form>
                        </div>
                    </MenuSider>
                </Spin>
            </div>
        );
    }
}
const mapStatetoProps = (state) => {
    return {
        authen: state.authen,
        detailMyOb: state.detailMyOb,
        set_basic_info: state.set_basic_info
    }
}
const mapDispatchProps = (dispatch) => {
    return {
        CLEAR_SITE: () => {
            dispatch({
                type: "CLEAR_SITE",
            })
        },
        SET_SITEID: (value) => {
            dispatch({
                type: "SET_SITEID",
                siteid: value
            })
        },
        SET_AREAID: (value) => {
            dispatch({
                type: "SET_AREAID",
                areaid: value
            })
        },
        SET_BASIC_INFO: (value) => {
            dispatch({
                type: "SET_BASIC_INFO",
                observation_id: value.observation_id,
                observation_date: value.observation_date,
                time: value.time,
                shift: value.shift,
                type_of_observed_people: value.type_of_observed_people,
                area: value.area,
                site: value.site
            })
        },
        CLEAR_BASIC_INFO: () => {
            dispatch({
                type: "CLEAR_BASIC_INFO",
            })
        },
        CLEAR_IMAGE_CATEGORY: () => {
            dispatch({
                type: "CLEAR_IMAGE_CATEGORY",
            })
        },

    }
}

const Newobservation_Basic_Info = Form.create()(Basic_Info);

export default connect(mapStatetoProps, mapDispatchProps)(Newobservation_Basic_Info)